module.exports = __webpack_public_path__ + "56cb0f248cb00129de3fd56854319ea3.MP3";